import { Card, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { ICandidateRevenue, IPosition } from 'wisestep-api';
import { WsIconMonyBag, WsIconChartLine, WsIconCoin, WsIconCalculator } from 'wisestep-base';

import BasicDetailsCard from './BasicDetailsCard';
import CalculationUnitCard from './CalculationUnitCard';
import RevenueDTO from './RevenueDTO';

interface IPotentialrevenue {
  jobRevenueInfo?: IPosition;
  candidateRevenueInfo?: ICandidateRevenue;
}

const PotentialRevenue = ({ jobRevenueInfo, candidateRevenueInfo }: IPotentialrevenue) => {
  const [jobRevenue, setJobRevenue] = useState<IPosition>();
  const [candidateRevenue, setCandidateRevenue] = useState<ICandidateRevenue>();
  useEffect(() => {
    setJobRevenue(jobRevenueInfo);
  }, [jobRevenueInfo]);
  useEffect(() => {
    setCandidateRevenue(candidateRevenueInfo);
  }, [candidateRevenueInfo]);

  const revenue: RevenueDTO = {
    feeArrangementName: jobRevenue
      ? jobRevenue?.feeArrangement?.feeArrangementLevel?.toString() ?? 'Not Available'
      : candidateRevenue
      ? candidateRevenue?.position?.feeArrangement?.feeArrangementLevel?.toString() ??
        'Not Available'
      : 'Not Available',
    arrangementType: jobRevenue
      ? jobRevenue?.feeArrangement?.contractType?.toString() ??
        jobRevenue.jobType ??
        'Not Available'
      : candidateRevenue
      ? candidateRevenue?.position?.feeArrangement?.contractType?.toString() ??
        candidateRevenue?.position?.jobType ??
        'Not Available'
      : 'Not Available',
    numberOfPosition: jobRevenue
      ? jobRevenue?.numberOfPositions?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.position?.numberOfPositions?.toString() ?? ''
      : '',
    contractDuration: 'demo',
    standardContract: jobRevenue
      ? jobRevenue?.revenueCalculatedFor?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.revenueCalculatedFor?.toString() ?? ''
      : '',
    maxSalary: jobRevenue
      ? jobRevenue?.salaryAmount?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.salaryAmount?.toString() ?? ''
      : '',
    potentialRevenueValue: jobRevenue
      ? jobRevenue?.potentialRevenue?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.potentialRevenue?.toString() ?? ''
      : '',

    grossRevenue: jobRevenue
      ? jobRevenue?.grossRevenue?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.grossRevenue?.toString() ?? ''
      : '',
    netRevenue: jobRevenue
      ? jobRevenue?.netFeeIncome?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.netFeeIncome?.toString() ?? ''
      : '',
    clientBillRate: jobRevenue
      ? jobRevenue?.clientBillRate?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.clientBillRate?.toString() ?? ''
      : '',
    maxPayRate: jobRevenue
      ? jobRevenue?.salaryAmount?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.salaryAmount?.toString() ?? ''
      : '',
    potrntialNetMargin: jobRevenue
      ? jobRevenue?.netMargin?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.netMargin?.toString() ?? ''
      : '',
    salaryCurrency: jobRevenue
      ? jobRevenue?.salaryCurrency?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.salaryCurrency?.toString() ?? ''
      : '',
    potentialRevenueCurrency: jobRevenue
      ? jobRevenue?.potentialRevenueCurrency?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.position?.potentialRevenueCurrency?.toString() ?? ''
      : '',
    potentialRevenueTimeSpan: jobRevenue
      ? jobRevenue?.potentialRevenueTimeSpan?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.potentialRevenueTimeSpan?.toString() ?? ''
      : '',
    netFeeIncomeTimeSpan: jobRevenue
      ? jobRevenue?.netFeeIncomeTimeSpan?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue.netFeeIncomeTimeSpan?.toString() ?? ''
      : '',
    grossRevenueTimeSpan: jobRevenue
      ? jobRevenue?.grossRevenueTimeSpan?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.grossRevenueTimeSpan?.toString() ?? ''
      : '',
    clientBillRateCurrency: jobRevenue
      ? jobRevenue?.clientBillRateCurrency?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.clientBillRateCurrency?.toString() ?? ''
      : '',
    netMarginTimeSpan: jobRevenue
      ? jobRevenue?.netMarginTimeSpan?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.netMarginTimeSpan?.toString() ?? ''
      : '',
    salaryTimeSpan: jobRevenue
      ? jobRevenue?.salaryTimeSpan?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.salaryTimeSpan?.toString() ?? ''
      : '',
    clientBillRateTimeSpan: jobRevenue
      ? jobRevenue?.clientBillRateTimeSpan?.toString() ?? ''
      : candidateRevenue
      ? candidateRevenue?.clientBillRateTimeSpan?.toString() ?? ''
      : '',
    jobDuration: jobRevenue
      ? jobRevenue?.jobDuration
      : candidateRevenue && candidateRevenue?.jobDuration
      ? candidateRevenue?.jobDuration?.toString()
      : '',
    jobDurationTimeSpan: jobRevenue
      ? jobRevenue?.jobDurationTimeSpan
      : candidateRevenue && candidateRevenue?.jobDurationTimeSpan
      ? candidateRevenue?.jobDurationTimeSpan?.toString()
      : '',
    payRateExpenses: candidateRevenue?.payRateExpenses ?? '',
    payRateExpensesCurrency: candidateRevenue?.payRateExpensesCurrency ?? '',
    payRateExpensesType: candidateRevenue?.payRateExpensesType ?? '',
    offeredPayRate: candidateRevenue?.offeredPayRate?.toString() ?? '',
    offeredPayRateTimeSpan: candidateRevenue?.offeredPayRateTimeSpan ?? '',
    offeredPayRateCurrency: candidateRevenue?.offeredPayRateCurrency ?? '',
  };
  return (
    <Grid container xs={12} spacing={2}>
      <Grid item xs={5} sx={{ display: 'flex', alignItems: 'stretch' }}>
        <Card variant="outlined" sx={{ flex: 1 }}>
          <BasicDetailsCard revenue={revenue} />
        </Card>
      </Grid>
      <Grid item xs={7}>
        <Grid container direction="row" spacing={2}>
          {revenue.arrangementType === 'PERMANENT' && (
            <>
              {revenue.maxPayRate && (
                <Grid item>
                  <CalculationUnitCard
                    value={revenue.maxPayRate?.toString() ?? ''}
                    Icon={WsIconMonyBag}
                    heading={'Maximum Salary'}
                    currency={revenue.salaryCurrency ?? ''}
                    timeSpan={''}
                  />
                </Grid>
              )}
              {revenue.potentialRevenueValue && (
                <Grid item>
                  <CalculationUnitCard
                    value={revenue.potentialRevenueValue?.toString() ?? ''}
                    Icon={WsIconChartLine}
                    heading="Potential Revenue"
                    currency={revenue.potentialRevenueCurrency?.toString() ?? ''}
                    timeSpan={''}
                  />
                </Grid>
              )}
            </>
          )}
          {(revenue.arrangementType === 'CONTRACT' || revenue.arrangementType === 'Contract') && (
            <>
              {revenue.clientBillRate && (
                <Grid item>
                  <CalculationUnitCard
                    value={revenue.clientBillRate?.toString() ?? ''}
                    Icon={WsIconChartLine}
                    heading="Client Bill Rate"
                    currency={revenue.clientBillRateCurrency?.toString() ?? ''}
                    timeSpan={revenue.clientBillRateTimeSpan?.toString() ?? ''}
                  />
                </Grid>
              )}
              {revenue.maxSalary &&
                (revenue.offeredPayRate === null || revenue.offeredPayRate === '0') && (
                  <Grid item>
                    <CalculationUnitCard
                      value={revenue.maxSalary?.toString() ?? ''}
                      Icon={WsIconMonyBag}
                      heading={candidateRevenue ? 'Submitted Pay Rate' : 'Max Pay Rate'}
                      currency={revenue.salaryCurrency?.toString() ?? ''}
                      timeSpan={revenue.salaryTimeSpan?.toString() ?? ''}
                    />
                  </Grid>
                )}
              {revenue.offeredPayRate && revenue.offeredPayRate !== '0' && (
                <Grid item>
                  <CalculationUnitCard
                    value={revenue.offeredPayRate?.toString() ?? ''}
                    Icon={WsIconMonyBag}
                    heading={'Offered Pay Rate'}
                    currency={revenue.offeredPayRateCurrency?.toString() ?? ''}
                    timeSpan={revenue.offeredPayRateTimeSpan?.toString() ?? ''}
                  />
                </Grid>
              )}
              {revenue.payRateExpenses && revenue.payRateExpenses !== '0' && (
                <Grid item>
                  <CalculationUnitCard
                    value={revenue.payRateExpenses?.toString() ?? ''}
                    Icon={WsIconMonyBag}
                    heading={'Payrate Expenses'}
                    currency={revenue.payRateExpensesCurrency?.toString() ?? ''}
                    timeSpan={revenue.payRateExpensesType?.toString() ?? ''}
                  />
                </Grid>
              )}
              {revenue.potrntialNetMargin && (
                <Grid item>
                  <CalculationUnitCard
                    value={revenue.potrntialNetMargin?.toString() ?? ''}
                    Icon={WsIconChartLine}
                    heading="Potential Net Margin"
                    currency={revenue.clientBillRateCurrency?.toString() ?? ''}
                    timeSpan={
                      revenue.netMarginTimeSpan?.toString() === 'HOURLY' ||
                      revenue.netMarginTimeSpan?.toString() === 'PerHour' ||
                      revenue.clientBillRateTimeSpan?.toString() === 'HOURLY' ||
                      revenue.clientBillRateTimeSpan?.toString() === 'PerHour'
                        ? 'Hour'
                        : ''
                    }
                  />
                </Grid>
              )}
            </>
          )}
          {revenue.grossRevenue && (
            <Grid item>
              <CalculationUnitCard
                value={revenue.grossRevenue?.toString() ?? ''}
                Icon={WsIconCoin}
                heading="Gross Revenue"
                currency={revenue.clientBillRateCurrency?.toString() ?? ''}
                timeSpan={
                  revenue.grossRevenueTimeSpan?.toString() && revenue?.standardContract
                    ? `${revenue.standardContract} Months`
                    : ''
                }
              />
            </Grid>
          )}

          {revenue.netRevenue && (
            <Grid item>
              <CalculationUnitCard
                value={revenue.netRevenue?.toString() ?? ''}
                Icon={WsIconCalculator}
                heading="Net Revenue"
                currency={revenue.clientBillRateCurrency?.toString() ?? ''}
                timeSpan={
                  revenue.netFeeIncomeTimeSpan?.toString() && revenue?.standardContract
                    ? `${revenue.standardContract} Months`
                    : ''
                }
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PotentialRevenue;
